import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import MobileMenuOverlay from './Components/MobileMenuOverlay';
import { NavItems } from '../AppNav/NavItems';

import powerDown from 'assets/utils/images/logout.svg';

import { logout } from 'actions/Auth';
import { downloadPdf } from 'actions/User';
import { connect } from 'react-redux';
import { get } from 'lodash';

import hamburger_menu from 'assets/utils/images/hamburger_menu.svg';
import hamburger_menu_open from 'assets/utils/images/hamburger_menu_open.svg';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { t } from 'i18n';
import { withTranslation } from 'react-i18next';

const getNav = (userRole) => {
  return NavItems.filter((el) => {
    if (el.disableForRoles && el.disableForRoles.indexOf(userRole) !== -1) return false;
    return true;
  });
};

const pagesWithFixedHeader = [
  '/update-user',
  '/update-organization',
  '/update-admin',
  '/view-admin',
  '/create-studio-user',
  '/create-hybrid-user',
  '/create-home-user',
  '/edit-license-type',
  '/view-license-type',
  '/create-license-type',
  '/create-organization',
  '/create-admin',
  '/view-user',
];

const checkHeaderFixed = (history) => {
  const path = get(history, 'location.pathname');
  return pagesWithFixedHeader.reduce((acc, el) => {
    if (acc) return acc;
    if (path.includes(el)) return true;
    return acc;
  }, false);
};

const Component = ({ logout, noUser = false, user, userRole, history }) => {
  const [menuOpen, toogleMenuVisibility] = useState(false);

  const toggleMenu = (state) => {
    const body = document.querySelector('body');
    if (state === true) {
      disableBodyScroll(body);
    } else {
      enableBodyScroll(body);
    }
    toogleMenuVisibility(state);
  };

  const isHeaderFixed = checkHeaderFixed(history);

  return (
    <>
      <div
        className={`d-header
            ${userRole === 'user' ? 'user-header' : 'admin-header'}
            ${isHeaderFixed ? 'd-header-fixed' : ''}
        `}
      >
        <div className="d-header-top">
          {userRole !== 'user' && (
            <div className="d-user-text">
              {t('auth.welcome', { name: get(user, 'name', get(user, 'preferred_username', '')) })}
            </div>
          )}
          <LanguageSwitcher />
          {noUser ? (
            <div className="d-logout-text" onClick={() => history.push('../login')}>
              {t('actions.login')}
            </div>
          ) : (
            <>
              {user ? (
                <div className="d-logout-text" onClick={() => logout()}>
                  <img src={powerDown} alt={t('actions.logout')} /> {t('actions.logout')}
                </div>
              ) : (
                <div className="d-logout-text" onClick={() => history.push('../login')}>
                  {t('actions.login')}
                </div>
              )}

              <div className="d-logout-img" onClick={() => logout()}>
                <img src={powerDown} alt={t('actions.logout')} />
              </div>
            </>
          )}
        </div>
        <div className="d-header-middle">
          <div
            className={menuOpen ? 'd-header-hamburger d-header-hamburger__open' : 'd-header-hamburger'}
            onClick={() => toggleMenu(!menuOpen)}
          >
            <img
              src={menuOpen ? hamburger_menu_open : hamburger_menu}
              className="d-header-hamburger-icon"
              alt={t('navigation.menu')}
            />
          </div>
        </div>
        <div className="d-header-bottom">
          {userRole !== 'user' && (
            <Link to="/users">
              <div className="d-header-tab">
                <div className="d-about-icon"></div>
                {t('navigation.usersManagement')}
              </div>
            </Link>
          )}
        </div>
      </div>
      <MobileMenuOverlay open={menuOpen} closeMenu={() => toggleMenu(false)} nav={getNav(userRole)} />
    </>
  );
};

const mapStateToProps = ({ UserRoles, Auth, Theme }) => ({
  userRole: UserRoles.userRole,
  user: Auth.user,
  darkTheme: Theme.darkTheme,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout.request()),
  startPdfDownload: () => dispatch(downloadPdf.request()),
  endPdfDownload: () => dispatch(downloadPdf.success()),
  //toggleDarkTheme: (payload) => dispatch({ type: 'SET_THEME', payload })
});

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Component)));
